const accommodationsPostbookingModule = require('../accommodation/accommodationPostBookingUrlServiceV2.js');

const DeeplinkAccommodationsController = function() {
    this.goToAccommodationsPostBooking = async function(bookingId, email) {
        // For now the buyPath is hardcoded
        const buyPath = 'HSA_FLIGHT_CONFIRMATION';
        const params = {
            bookingId: bookingId,
            email: email,
            buyPath: buyPath,
        };

        const postbookingURL = await accommodationsPostbookingModule.get(params);
        if (postbookingURL.fallbackUrl) throw new AccommodationPostbookingModuleError();
        Odigeo.Session.set('isAccommodationPostBooking', true);
        location.href = postbookingURL.url;
    };
};

module.exports = DeeplinkAccommodationsController;

class AccommodationPostbookingModuleError extends Error {
    constructor() {
        super();
        this.message = 'No redirection to fallback url';
    }
}
